export const sidebarTypes = {
    TOGGLE: 'Sidebar toggle',
    OPEN: 'Sidebar is active',
    CLOSE: 'Sidebar is closed',
    ERROR: 'Sidebar has error',
    PREV_STEP: 'Sidebar - previous step',
    NEXT_STEP: 'Sidebar - next step',
};
